(function() {
'use strict';

angular
    .module('dashboard')
    .factory('deliveryAddressService', deliveryAddressService);

function deliveryAddressService($http) {
    const url = '/api2/attractions/deliveryaddress/';

    return {
        get(bookingId) {
            return $http.get(url + bookingId);
        },
        put(bookingId, deliveryAddress) {
            return $http.put(
                String.format('{0}/{1}', url, bookingId), deliveryAddress);
        }
    };
}
})();
